import { handleActions } from 'redux-actions';
import actionTypes from './notificationActionType';
import configSvc from 'services/configService';

const initState = {
  message: '',
  success: false,
  visible: false
};

export default handleActions({
  [actionTypes.NOTIFICATION_EDITOR_UPDATE]: (state, { payload }) => {
    const { event, success } = payload;
    let updateMsg = `Your event, "${event.name}" has been succesfully updated!`;
    if (configSvc.isEditEnabled()) {
      updateMsg = `Your event, "${event.name}" has been succesfully updated! ` +
      ' The new definition will be in effect in about 30 minutes';
    }
    let finalMessage = '';
    if (success) {
      switch (event.type) {
        case 'add':
          // eslint-disable-next-line max-len
          finalMessage = `Your event, "${event.name}" has been succesfully defined and will be available in about 30 minutes!`;
          break;
        case 'update':
          finalMessage = updateMsg;
          break;
        case 'delete':
          finalMessage = `Your event, "${event.name}" has been succesfully deleted!`;
          break;
        default:
          finalMessage = 'Your changes has been succesfully saved!';
          break;
      }
    } else {
      finalMessage = 'Oops, an error ocurred.';
    }
    return {
      visible: true,
      message: finalMessage,
      success
    };
  },

  [actionTypes.NOTIFICATION_EDITOR_HIDE]: (state, { payload }) => {
    return initState;
  }

}, initState);



/** WEBPACK FOOTER **
 ** ./src/redux/modules/notification/notification.js
 **/